module.exports = __webpack_public_path__ + "images/file_icons_v2/sql-8ac7a2f18230562bcd35bc97e3d88a14.svg";